import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import SettingsManagerContainer from './components/SettingsManager/SettingsManagerContainer';
import './UserSettings.css';

const UserSettings = () => (
  <PageContainer pageName="users-settings">
    <SettingsManagerContainer />
  </PageContainer>
);

export default UserSettings;
